<!-- 商户报表 -->
<template>
  <div class="comContent body-box">
    <div class="body-tools">
      <div class="body-tools-left">
        <el-form ref="formTool" :model="formTool" :inline="true">
          <el-form-item label="" prop="">
            <el-input v-model="formTool.shopName" size="small" placeholder="请输入商户名称" clearable />
          </el-form-item>
          <el-form-item label="" prop="">
            <el-cascader v-model="formTool.address" ref="areaRef" size="small" placeholder="请选择所在区域" clearable
            :options="areaTreeData" :props="cascaderProps" @change="areaChange"></el-cascader>
          </el-form-item>
          <el-form-item label="" prop="">
            <el-select v-model="formTool.shopType" size="small" placeholder="请选择商户类型" clearable>
              <el-option v-for="item in typesOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单创建时间" prop="">
            <el-date-picker v-model="formTool.orderTime" size="small" clearable type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="" prop="phone">
            <MyButton type="primary" text="查询" @click="goSearch" />
            <el-button size="small" @click="formToolReset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="body-tools-right">
        <MyButton type="primary" text="导出" @click="goExport" />
      </div>
    </div>
    <div class="body-table">
      <MyTable :table-data="tableData"
        max-height="calc(100% - 44px)"
        :index="false"
        :selection="false"
        :page="page"
        :operation="false"
        :table-option.sync="tableOption"
        @page-change="getList"
        @sort-change="sortChange"
        @handleSelectionChange="currentChange">
        <template slot="type" slot-scope="scope">
          <span>{{ scope.row.type=='ios'?'苹果系统':'安卓系统' }}</span>
        </template>
        <template slot="tools" slot-scope="scope">
          <div style="display:flex">
            <el-link type="primary" class="table-link" :underline="false" size="small" @click="goOpDetail(scope.row)">运营详情</el-link>
            <el-link type="primary" class="table-link" :underline="false" size="small" @click="goShopDetail(scope.row)">商户详情</el-link>
          </div>
        </template>
      </MyTable>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import MyButton from '@/components/myButton';
import MyTable from '@/components/myTable';
import { getAreaTree } from '@/api/shopmange/index';
import { getListByType } from "@/api/businessManage";
import { queryGoodsSalesEcharts, queryGoodsSalesEchartsExport } from "@/api/statistics";
import { getTempDataInfoByShopId } from '@/api/qualification/qualification';
export default {
  name:'ReportMerchantList',
  components: { Pagination, MyButton, MyTable },
  data() {
    return {
      formTool: {
        shopName:'',
        address:[],
        shopType:'',
        orderTime:'',
      },
      typesOptions: [],
      tableData: [],
      tableOption: [
        { label: '商户名称', prop: 'payee_shop_name', minWidth: '100px' },
        { label: '运营人员及联系方式', prop: 'payee_concat_name', minWidth: '160px' },
        { label: '商户所在区域', prop: 'payee_province_name', width: '140px' },
        { label: '商户类型', prop: 'payee_shop_type_name', width: '110px' },
        { label: '在售商品数量', prop: 'online_skui_cnt', width: '120px',sortable:'custom' },
        { label: '订单量', prop: 'order_cnt', width: '90px',sortable:'custom' },
        { label: '销售额(元)', prop: 'amount', width: '120px',sortable:'custom' },
        { label: '客单价(元)', prop: 'avg_order_amount', width: '100px',sortable:'custom' },
        { label: '保证金余额(元)', prop: 'guarantee_balance', width: '130px',sortable:'custom' },
        { label: '保证金可用余额(元)', prop: 'guarantee_use_amount', width: '160px',sortable:'custom' },
        { label: '操作', prop: 'tools', slot: true, width: '140px' }
      ],
      page: { total: 10, current: 1, size: 10 },
      sortStatus:'up',
      sortType:'1',// 排序字段: 在售商品数量 1;订单量 2;销售额（元） 3;客单价（元） 4;保证金余额（元） 5;保证金可用余额（元） 6;
      cascaderProps: {
        label:'rname',
        value:'id',
      },
      areaTreeData:[],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.$store.dispatch('user/setMTabName', '');//初始化商户详情栏目
    this.getArea();
    this.getShopTypes();
    this.initData();
  },
  mounted() {

  },
  methods: {
    goOpDetail(el){
      let url = `/reportMerchant/reportMerchant-reportDetail?shopId=${el.payee_shop_id}&shopName=${el.payee_shop_name}`
      // let url = '/reportMerchant/reportMerchant-mainMerchant?shopId=1606205771220635650&type=view&requestId=659fbaeae4b05206f4e3c812'
      this.$router.push(url);
    },
    goShopDetail(el){
      getTempDataInfoByShopId(el.payee_shop_id ).then(res=>{
        if(res.data){
          const { requestId } = res.data
          let url = `/reportMerchant/reportMerchant-mainMerchant?shopId=${el.payee_shop_id}&type=viewNoEdit&requestId=${requestId}`;
          this.$router.push(url);
          // let url = `/reportMerchant/reportMerchant-mainMerchant?shopId=${el.payee_shop_id}&type=view&requestId=659fbaeae4b05206f4e3c812`;
          // this.$router.push(url);
        }
      })
    },
    goSearch(){
      this.sortStatus = 'up';
      // this.sortType = '1';
      this.initData();
    },
    sortChange(el){
      const { column, prop, order } = el; // order释义：descending:降,ascending:升,为空时代表不选中
      console.log(column, prop, order)
      // 执行条件搜索操作
      let propNames = {
        online_skui_cnt: { label: '在售商品数量', value: '1' },
        order_cnt: { label: '订单量', value: '2' },
        amount: { label: '销售额（元）', value: '3' },
        avg_order_amount: { label: '客单价（元）', value: '4' },
        guarantee_balance: { label: '保证金余额（元）', value: '5' },
        guarantee_use_amount: { label: '保证金可用余额（元）', value: '6' },
      }
      // sortType:'1',// 排序字段: 在售商品数量 1;订单量 2;销售额（元） 3;客单价（元） 4;保证金余额（元） 5;保证金可用余额（元） 6;
      // 执行条件搜索操作
      this.sortStatus = order == 'descending'?'down':'up';
      this.sortType = (order && propNames[prop]) ? propNames[prop].value : '1';
      this.initData();
    },
    //获取整个省市区的树
    getArea () {
      getAreaTree({ level: 1 }).then(res => {
        this.areaTreeData = res.data || [];
      })
    },
    areaChange(val){
      const el = this.$refs.areaRef.getCheckedNodes();
      let areas = []
      if(val.length>0){
        areas = el[0].pathNodes.map(li=>{
          return { id: li.value, name: li.label }
        })
      }
      console.log(areas);
    },
    getShopTypes () {
      // 获取客户/商户类型列表
      getListByType({
        type: 1, //0 客户类型  1商户类型
      }).then((res) => {
        this.typesOptions = res.data?res.data.map(li=>{
          return { value: li.typeCode, label: li.typeName }
        }):[]
      });
    },
    formToolReset () {
      this.formTool = {
        shopName:'',
        address:[],
        shopType:'',
        orderTime:'',
      }
      // this.$refs.formTool.resetFields()
      this.initData()
    },
    currentChange(){
      console.log(e,this.page)
    },
    goExport(){
      let obj = this.getParams('export');
      queryGoodsSalesEchartsExport(obj,'客户报表列表'); //执行文件获取及下载
    },
    initData(){
      this.page.current = 1;
      this.getList();
    },
    getList(){
      let obj = this.getParams(this.sortStatus);
      // console.log('getList-重新加载数据', obj)
      let totalObj = this.getParams('total');
      queryGoodsSalesEcharts(obj).then(list=>{
        this.tableData = list || [];
      })
      queryGoodsSalesEcharts(totalObj).then(list=>{
        // 获取总条数
        let total = 0;
        if(list && list.length>0){
          total = parseInt(list[0].cnt);
        }
        this.page.total = total;
      })
    },
    getParams(status = 'up'){
      const { current, size } = this.page;
      const { shopName, address, shopType, orderTime } = this.formTool;
      let priviceCode = '';
      if(address && address.length>0){
        priviceCode = address[0];
      }

      let firstSTime = '';
      let firstETime = '';
      if(orderTime && orderTime.length>0){
        firstSTime = orderTime[0].replaceAll('-', '');
        firstETime = orderTime[1].replaceAll('-', '');
      }
      let types = {
        up: 98, down:99, total:100, export:101
      }
      let type = types[status];
      let params = [
        firstSTime,firstSTime, // 首次下单时间(开始时间)
        firstETime,firstETime, // 首次下单时间(结束时间)
        shopName || '',shopName || '',// ERPID
        priviceCode,priviceCode, // 省编码
        shopType || '',shopType || '', // 客户名称
      ]
      let paramsMore = [
        this.sortType, // 排序字段: 在售商品数量 1;订单量 2;销售额（元） 3;客单价（元） 4;保证金余额（元） 5;保证金可用余额（元） 6;
        size, // 每页行数
        (current - 1)*size, // 第几行开始
      ]
      return { type, params: (status=='up' || status == 'down') ? [ ...params, ...paramsMore ] : params}
    },
  },
  // beforeCreate() { },
  // beforeMount() { },
  // beforeUpdate() { },
  // updated() { },
  // beforeDestroy() { },
  // destroyed() { },
  // activated() { },
}
</script>
<style lang='scss' scoped>

.body{
  &-tools{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 16px;
    &-left{
      width: calc(100% - 90px);
    }
    &-right{
      width: 90px;
      text-align: right;
    }
    ::v-deep .el-form{
      &-item{
        margin-bottom: 6px !important;
      }
    }
  }
  &-table{
    height: calc(100% - 64px);
  }
}
.table{
  &-link{
    margin-right: 10px;
    &:last-child{
      margin-right: 0;
    }
  }
}
</style>
